<template>
  <svg viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.900146 10.0002V16.6C0.900146 17.0376 1.07398 17.4573 1.38341 17.7667C1.69284 18.0762 2.11251 18.25 2.55011 18.25H12.4499C12.8875 18.25 13.3071 18.0762 13.6166 17.7667C13.926 17.4573 14.0998 17.0376 14.0998 16.6V10.0002M10.7967 5.04992L7.49677 1.75L4.19685 5.04992M7.49837 1.75V12.4747" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
